'use strict'
import { createSlice } from '@reduxjs/toolkit'
import DtoManagementUnit from '../dto/DtoManagementUnit'

export const initialState = {
    managementUnit: {},
    managementUnits: [],
    managementUnitsRestrictions: [],
    managementUnitsVolumes: {},
}

const store = createSlice({
    name: 'managementUnit',
    initialState,
    reducers: {
        managementUnit: (state, action) => {
            state.managementUnit = new DtoManagementUnit(action.payload)
        },
        managementUnits: (state, action) => {
            state.managementUnits = action.payload.map(managementUnit => new DtoManagementUnit(managementUnit))
        },
        managementUnitsRestrictions: (state, action) => {
            state.managementUnitsRestrictions = action.payload
        },
        managementUnitsVolumes: (state, action) => {
            state.managementUnitsVolumes = { ...state.managementUnitsVolumes, [action.payload.idUG]: action.payload.managementUnitVolumes }
        },
        cleanManagementUnitsVolumes: (state) => {
            state.managementUnitsVolumes = {}
        },
    },
})

export const ManagementUnitActionConstant = store.actions
export default store.reducer